import { Box, Typography } from "@mui/material"

const Header = ({ title }) => {
    return (
        <Box>
            <Typography
                color='#2A2A2A'
                fontWeight='bold'
                fontSize='19px'
                sx={{ mb: '5px' }}
            >
                {title}
            </Typography>
        </Box>
    )
}

export default Header